import { CommonResponse, deleteData, get, patch, post } from './common.ts'

/**
 * (01)
 * 수업방 정보 조회
 */

// GET /classrooms/{sessionId}
interface GetClassRoomInfoRequestParams {
  sessionId: string
}

export const getClassRoomInfo = async (
  request: GetClassRoomInfoRequestParams,
): Promise<CommonResponse<null>> => {
  return await get(`/classrooms/${request.sessionId}`)
}

/**
 * (02)
 * 학생 수업방 입장
 */

// POST /classrooms/{sessionId}/enter/{studentId}
interface PostClassRoomStudentEnterParams {
  sessionId: string
  studentId: string
}
interface PostClassRoomStudentEnterBody {}

export const PostClassRoomStudentEnter = async (
  request: PostClassRoomStudentEnterParams,
  body: PostClassRoomStudentEnterBody,
): Promise<CommonResponse<null>> => {
  return await post(`/classrooms/${request.sessionId}/enter/${request.studentId}`, body)
}

/**
 * (03)
 * 학생 수업방 퇴장
 */

// POST /classrooms/{classroomId}/leave{studentId}
interface PostClassRoomStudentLeaveParams {
  classroomId: string
  studentId: string
}
interface PostClassRoomStudentLeaveBody {}

export const PostClassRoomStudentLeave = async (
  request: PostClassRoomStudentLeaveParams,
  body: PostClassRoomStudentLeaveBody,
): Promise<CommonResponse<null>> => {
  return await post(`/classrooms/${request.classroomId}/leave/${request.studentId}`, body)
}

/**
 * (04)
 * 수업방 종료
 */

// POST /classrooms/{classroomId}/close
interface PostClassRoomCloseParams {
  classroomId: string
}
interface PostClassRoomCloseBody {}

export const PostClassRoomClose = async (
  request: PostClassRoomCloseParams,
  body: PostClassRoomCloseBody,
): Promise<CommonResponse<null>> => {
  return await post(`/classrooms/${request.classroomId}/close`, body)
}

/**
 * (05)
 * 보드 생성 - 자료
 */

// POST /classrooms/{classroomId}/board/document
interface PostClassRoomBoardDocumentParams {
  classroomId: string
}
interface PostClassRoomBoardDocumentBody {
  currentPageNumber: number
  documentImageIds: string[]
}

export const PostClassRoomBoardDocument = async (
  request: PostClassRoomBoardDocumentParams,
  body: PostClassRoomBoardDocumentBody,
): Promise<CommonResponse<null>> => {
  return await post(`/classrooms/${request.classroomId}/board/document`, body)
}

/**
 * (06)
 * 수업방 상태 변경
 */

// PATCH /classrooms/{classroomBoardId}
interface PatchClassRoomStatusParams {
  classroomBoardId: string
}
interface PatchClassRoomStatusBody {
  mode: string
  allowStudentEdit: boolean
  lastViewedPage: number
  isGridView: boolean
  studentBoardId: string
}

export const PatchClassRoomStatus = async (
  request: PatchClassRoomStatusParams,
  body: PatchClassRoomStatusBody,
): Promise<CommonResponse<null>> => {
  return await patch(`/classrooms/${request.classroomBoardId}`, body)
}

/**
 * (07)
 * 수업방 입장 학생 목록
 */

// GET /classrooms/{classroomId}/students
interface GetClassRoomStudentsRequest {
  classroomId: string
}
interface GetClassRoomStudentsResponse {
  id: string
  studentId: string
  admissionYear: number
  grade: number
  classNumber: number
  studentNumber: number
  name: string
  status: string
  schoolId: string
  majorGroup: string
  isActive: boolean
}

export const getClassRoomStudents = async (
  request: GetClassRoomStudentsRequest,
): Promise<CommonResponse<GetClassRoomStudentsResponse>> => {
  return await get(`/classrooms/${request.classroomId}/students`)
}

/**
 * (08)
 * 보드 목록 조회
 */

// GET /classrooms/{classroomId}/board
interface GetClassRoomBoardRequest {
  classroomId: string
}
interface GetClassRoomBoardResponse {
  classroomBoard: {
    id: string
    pageNum: number
    backgroundImageId: string
    backgroundImageUrl: string
    classroomId: string
  }[]
}

export const getClassRoomBoard = async (
  request: GetClassRoomBoardRequest,
): Promise<CommonResponse<GetClassRoomBoardResponse>> => {
  return await get(`/classrooms/${request.classroomId}/board`)
}

/**
 * (09)
 * 보드 삭제
 */

// DELETE /classrooms/{classroomId}/board
interface DeleteClassRoomBoardParams {
  classroomId: string
}
interface DeleteClassRoomBoardBody {
  deletedBoardIds: string[]
}

export const deleteClassRoomBoard = async (
  request: DeleteClassRoomBoardParams,
  body: DeleteClassRoomBoardBody,
): Promise<CommonResponse<null>> => {
  return await deleteData(`/classrooms/${request.classroomId}/board`, body)
}

/**
 * (10)
 * 새 페이지 추가
 */

// POST /classrooms/{classroomId}/board/new-page
interface PostClassRoomBoardNewPageParams {
  classroomId: string
}
interface PostClassRoomBoardNewPageBody {
  currentPageNumber: number
}

export const PostClassRoomBoardNewPage = async (
  request: PostClassRoomBoardNewPageParams,
  body: PostClassRoomBoardNewPageBody,
): Promise<CommonResponse<null>> => {
  return await post(`/classrooms/${request.classroomId}/board/new-page`, body)
}

/**
 * (11)
 * 보드 이동
 */

// POST /classrooms/{classroomId}/board/move
interface PostClassRoomBoardMoveParams {
  classroomId: string
}
interface PostClassRoomBoardMoveBody {
  targetPageNumber: number
  boardIds: string[]
}

export const PostClassRoomBoardMove = async (
  request: PostClassRoomBoardMoveParams,
  body: PostClassRoomBoardMoveBody,
): Promise<CommonResponse<null>> => {
  return await post(`/classrooms/${request.classroomId}/board/move`, body)
}

/**
 * (12)
 * 보드 생성 - 보드
 */

// POST /classrooms/{classroomId}/board
interface PostClassRoomBoardParams {
  classroomId: string
}
interface PostClassRoomBoardBody {
  currentPageNumber: number
  boardIds: string[]
}

export const PostClassRoomBoard = async (
  request: PostClassRoomBoardParams,
  body: PostClassRoomBoardBody,
): Promise<CommonResponse<null>> => {
  return await post(`/classrooms/${request.classroomId}/board`, body)
}

/**
 * (13)
 * 수업방 오픈
 */

// POST /classrooms/{classroomId}/open
interface PostClassRoomOpenRequestParams {
  classroomId: string
}
interface PostClassRoomOpenRequestBody {}

export const postClassRoomOpen = async (
  request: PostClassRoomOpenRequestParams,
  body: PostClassRoomOpenRequestBody,
): Promise<CommonResponse<null>> => {
  return await post(`/classrooms/${request.classroomId}/open`, body)
}

/**
 * (14)
 * 학생 보드 그리드 조회
 */

// GET /classrooms/{classroomBoardId}/student-boards
interface GetClassRoomStudentBoardsGridRequest {
  classroomBoardId: string
}
interface GetClassRoomStudentBoardsGridResponse {
  studentBoard: {
    id: string
    backgroundImageId: string
    backgroundImageUrl: string
    classroomBoardId: string
    studentId: string
  }[]
  student: {
    id: string
    studentId: string
    admissionYear: number
    grade: number
    classNumber: number
    studentNumber: number
    name: string
    status: string
    schoolId: string
    majorGroup: string
    isActive: boolean
  }[]
}

export const getClassRoomStudentBoardsGrid = async (
  request: GetClassRoomStudentBoardsGridRequest,
): Promise<CommonResponse<GetClassRoomStudentBoardsGridResponse>> => {
  return await get(`/classrooms/${request.classroomBoardId}/student-boards`)
}

/**
 * (15)
 * 학생 개별 보드 조회
 */

// GET /classrooms/{classroomBoardId}/student-board/{studentId}
interface GetClassRoomStudentBoardForEachRequest {
  classroomBoardId: string
  studentId: string
}
interface GetClassRoomStudentBoardForEachResponse {
  id: string
  backgroundImageId: string
  backgroundImageUrl: string
  classroomBoardId: string
  studentId: string
}

export const getClassRoomStudentBoardForEach = async (
  request: GetClassRoomStudentBoardForEachRequest,
): Promise<CommonResponse<GetClassRoomStudentBoardForEachResponse>> => {
  return await get(`/classrooms/${request.classroomBoardId}/student-board/${request.studentId}`)
}
